import { getIcon } from "@fluentui/react-icons-compat";
import type { IconContent } from "../components/CommonIconTypes.type";

export const getIconContent = (iconName?: string): IconContent => {
  const { code, subset } = getIcon(iconName) || {
    subset: {},
    code: undefined,
  };

  if (!code) {
    return {};
  }

  return {
    iconCode: code,
    iconClassName: subset.className,
    mergeImageProps: subset.mergeImageProps,
  };
};
